import authService from '@/api/authService';
import DefaultHeader from '@/components/header/defaultHeader';
import { Alert, AppShell } from '@mantine/core';
import { useHeadroom } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';
import { IconBarrierBlock } from '@tabler/icons-react';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { useTranslator } from 'translations';

export const Route = createFileRoute('/_auth')({
    component: RouteComponent,

    async beforeLoad({ location }) {
        const login = await authService.requireLogin(location.href);

        if (login.maintenance?.enabled && !login.maintenanceExempt) {
            throw redirect({
                to: '/maintenance',
                search: {
                    redirect: location.href,
                },
            });
        }
    },
});

function RouteComponent() {
    const t = useTranslator();
    const isPinned = useHeadroom({ fixedAt: 50 });
    const [appLogin] = authService.appLogin.useCache();

    return (
        <>
            <AppShell
                header={{
                    height: 64,
                    offset: false,
                    collapsed: !isPinned,
                }}
            >
                <AppShell.Header>
                    <DefaultHeader />
                </AppShell.Header>

                <AppShell.Main
                    css={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: 'var(--app-shell-header-height)',
                    }}
                >
                    {appLogin?.maintenance?.enabled && (
                        <Alert
                            color="orange"
                            icon={<IconBarrierBlock />}
                            title={t('maintenance.adminBanner')}
                            css={{ margin: 'var(--mantine-spacing-sm)' }}
                        />
                    )}

                    <Outlet />
                </AppShell.Main>
            </AppShell>

            <Notifications />
            <TanStackRouterDevtools />
        </>
    );
}
